import { render } from "./OrganizationSearch.vue?vue&type=template&id=74d1f695&scoped=true"
import script from "./OrganizationSearch.vue?vue&type=script&lang=js"
export * from "./OrganizationSearch.vue?vue&type=script&lang=js"

import "./OrganizationSearch.vue?vue&type=style&index=0&id=74d1f695&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d1f695"]])

export default __exports__